import { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import OnboardingLayout from "./components/OnboardingLayout";
import AlreadyRegistered from "./pages/AlreadyRegistered";
import StartPage from "./pages/StartPage";
import Step from "./components/Step";
import Recommendation from "./pages/Recommendation";
import useScreenTracking from "./hooks/useScreenTracking";
import AppDownload from "./pages/AppDownload";
import Mixpanel from "./services/tracking";
import HypertensionLandingPage from "./pages/HypertensionLandingPage";

function App() {
  useScreenTracking();

  useEffect(() => {
    const handler = () => {
      // @ts-ignore
      if (window.Cookiebot.consent.statistics) {
        Mixpanel.init();
      }
    };

    window.addEventListener("CookiebotOnConsentReady", handler);

    return () => window.removeEventListener("CookiebotOnConsentReady", handler);
  }, []);

  return (
    <Routes>
      <Route path="/">
        <Route index element={<StartPage />} />
        <Route path="/hypertoni" element={<HypertensionLandingPage />} />
        <Route path="/steg" element={<OnboardingLayout />}>
          <Route index element={<Navigate to="/" />} />
          <Route path="/steg/:slug" element={<Step />} />
        </Route>
        <Route path="/rekommendation" element={<Recommendation />} />
        <Route path="/ladda-ner" element={<AppDownload />} />
        <Route path="/redan-registrerad" element={<AlreadyRegistered />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
